import type { TranslationDict } from './ja'

export const fr: TranslationDict = {
  appTitle: 'Lucky Animal Territory',
  help: 'Règles',
  helpAria: 'Règles',
  settings: 'Réglages',
  settingsAria: 'Réglages',
  close: 'Fermer',
  closeAria: 'Fermer',
  player: 'Joueur',
  highscore: 'Meilleur score',
  start: 'Commencer',
  staminaEmpty: 'Pas assez d’endurance',
  ranking: 'Guerre de Territoire',
  difficultyTitle: 'Choisir la difficulté',
  difficultyStart: 'Commencer avec ce niveau',
  back: 'Retour',
  today: 'Aujourd’hui',
  weekly: 'Cette semaine',
  alltime: 'Général',
  loading: 'Chargement...',
  noScores: 'Aucun score pour le moment. Deviens le premier champion !',
  loadFailed: 'Échec du chargement',
  you: 'Vous',
  youConstant: 'VOUS',
  language: 'Langue',
  languageNote: 'Prend en charge 18 langues, dont le japonais.',
  bgm: 'BGM',
  se: 'Effets sonores',
  soundEnableAria: 'Activer le son',
  soundDisableAria: 'Couper le son',
  adWatch: 'Voir la pub entière',
  adCancel: 'Plus tard',
  rankSuffix: 'e',
  earnedPoints: 'a gagné {score} pts',
  helpGoalTitle: '🎯 Objectif',
  helpGoalText: 'Placez des pièces sur le plateau 9x9 et agrandissez vos territoires connectés. Le score le plus élevé l’emporte.',
  helpWinTitle: '🏆 Conditions de victoire',
  helpWinFive: 'Alignez cinq pièces verticalement, horizontalement ou en diagonale pour une victoire instantanée.',
  helpWinScore: 'Si le plateau est plein, le score le plus élevé l’emporte. Pas de match nul.',
  helpScoreTitle: '💯 Score',
  helpLineBonus: 'Bonus de ligne : marquez des points pour des lignes de 3, 4 et 5 pièces.',
  helpClusterBonus: 'Bonus de territoire : marquez plus de points à mesure que vos groupes connectés grandissent.',
  helpKomi: 'Komi : le second joueur bénéficie d’un bonus de +10% au score.',
  helpControlsTitle: '🖱️ Commandes',
  helpControlsText: 'À votre tour, appuyez sur une case vide pour placer une pièce.',
  helpTipsTitle: '💡 Conseils',
  helpTipHell: 'Essayez HELL pour le défi le plus difficile.',
  helpTipCluster: 'Ne cherchez pas seulement l’alignement de cinq. Les grands groupes connectés augmentent aussi votre score.',
  resultWinFive: '🎉 Cinq alignés ! Vous avez gagné !',
  resultWinScore: '🎉 Victoire au score ! Vous avez gagné !',
  resultLoseFive: '😿 Le CPU a aligné cinq pièces !',
  resultLoseScore: '😿 Défaite au score. Réessayez !',
  resultDraw: '🤝 Égalité',
  newHighscore: '🏆 Nouveau meilleur score !',
  scoreNone: 'Aucun score',
  clusterBonus: 'Bonus de territoire',
  retry: 'Rejouer',
  titleBack: 'Titre',
  scoreHintPlaceStone: 'Placez un pion',
  best: 'Meilleur',
  clusterUnit: 'territoire',
  lineCount: '{len} alignés x{count}',
  turnCount: 'Coup {count} · {difficulty}',
  boardPlayerPiece: 'Votre pièce',
  boardCpuPiece: 'Pièce du CPU',
  boardPlayerAlt: 'Vous',
  boardCpuAlt: 'CPU',
  boardCellPosition: 'ligne {row}, colonne {col}',
  boardPlaceable: 'plaçable',
  boardEmpty: 'case vide',
  boardFlower: 'a une fleur',
  firstPlayerAlt: 'Premier joueur',
  playerFirst: 'Vous commencez !',
  playerSecond: 'Vous jouez en second (+{bonus}% de komi)',
  cpuFirst: 'Le CPU commence !',
  finalePlayerWin: 'Vous avez gagné !',
  finaleCpuWin: 'Le CPU a gagné !',
  finaleFive: 'Cinq alignés !',
  finaleTerritory: 'Bataille de territoire !',
  winnerAlt: 'Gagnant',
  loadingBoot: 'Démarrage...',
  loadingConnect: 'Connexion...',
  loadingProfile: 'Chargement du profil...',
  loadingAssets: 'Chargement des ressources...',
  loadingReady: 'Prêt',
  reauthRequiredTitle: 'Connexion requise',
  startupFailedTitle: 'Échec du démarrage',
  reauthButton: 'Se reconnecter',
  reloadButton: 'Recharger',
  lineReloginButton: 'Connexion LINE',
  reauthReason: 'Votre session a expiré. Veuillez vous reconnecter.',
  errorReauth: 'Votre session a expiré. Veuillez vous reconnecter.',
  errorForbidden: 'Vous n’avez pas la permission d’utiliser ce jeu.',
  errorNotFound: 'Données du jeu introuvables.',
  errorRateLimited: 'Le réseau est encombré. Veuillez patienter et réessayer.',
  errorServer: 'Impossible de se connecter au serveur. Veuillez patienter et recharger.',
  errorCommunication: 'Une erreur de communication est survenue. Veuillez recharger.',
  errorNetwork: 'Impossible de se connecter au réseau. Vérifiez votre connexion et rechargez.',
  errorStartup: 'Échec du démarrage. Veuillez recharger.',
  settingsTabGeneral: 'Réglages',
  settingsTabAccount: 'Compte',
  settingsTabInfo: 'Info',
  account: 'Compte',
  linked: 'Lié',
  guest: 'Invité',
  loggedInWith: 'Connecté avec {provider}',
  loggedIn: 'Connecté',
  playingAsGuest: 'Vous jouez actuellement en tant qu’invité.',
  appleLoginBusy: 'Connexion avec Apple...',
  appleLogin: 'Se connecter avec Apple',
  googleLoginBusy: 'Connexion avec Google...',
  googleLogin: 'Se connecter avec Google',
  logoutBusy: 'Déconnexion...',
  logout: 'Se déconnecter',
  logoutSuccess: 'Déconnecté',
  logoutFailed: 'Échec de la déconnexion',
  appInfo: 'Informations sur l’application',
  appName: 'Nom de l’application',
  version: 'Version',
  legalInfo: 'Mentions légales',
  terms: 'Conditions d’utilisation',
  privacy: 'Politique de confidentialité',
  operator: 'Opérateur',
  contact: 'Contact',
  copyTap: 'Appuyez pour copier',
  idCopied: 'ID copié',
  copyFailed: 'Échec de la copie',
  other: 'Autre',
  reportAd: 'Signaler une publicité inappropriée',
  privacyChoices: 'Ad privacy choices',
  profileEdit: 'Modifier le profil',
  displayName: 'Nom d’affichage',
  displayNamePlaceholder: 'Entrez un nom',
  chooseIcon: 'Choisir une icône',
  iconLoadFailed: 'Échec du chargement des icônes.',
  saveFailed: 'Échec de l’enregistrement. Veuillez réessayer.',
  noIcons: 'Aucune icône disponible.',
  save: 'Enregistrer',
  saving: 'Enregistrement...',
  staminaAria: 'Endurance {stamina} / {max}',
  nextRecovery: 'Prochaine récupération dans {time}',
  adPlaying: 'Publicité en cours...',
  recoverFullAd: 'Voir une pub pour récupérer toute l’endurance',
  dailyBonusAria: 'Voir la pub entière pour +5 d’endurance',
  dailyBonusAd: 'Voir une pub pour +5 d’endurance',
  legalLastUpdated: 'Dernière mise à jour : {date}',
  privacyTitle: 'Politique de confidentialité',
  termsTitle: 'Conditions d’utilisation',
  adPlayingAria: 'Publicité en cours',
  adBadge: '▶ Pub',
  adRemaining: '{seconds}s restantes',
  adDevHint: 'Publicité de test. En production, une vidéo AdMob sera diffusée.',
  adRewardRequirement: 'Regardez la pub jusqu’à la fin pour recevoir cette récompense.',
  adRewardStaminaDetail: 'Récompense : endurance restaurée au maximum',
  adRewardDailyBonusDetail: 'Récompense : +{amount} endurance comme bonus quotidien',
  adRewardIncompleteNote: 'Si vous fermez avant la fin, vous ne recevrez pas la récompense.',
  adSkipAria: 'Passer la pub',
  adSkip: 'Passer ✕',
  adSkipAfter: 'Passer dans {seconds}s',
  offlineMessage: 'Impossible de se connecter au serveur. Certaines fonctionnalités peuvent être indisponibles.',
  reconnecting: 'Reconnexion...',
  reconnect: 'Se reconnecter',
  signInTitle: 'Se connecter',
  signInBusy: 'Connexion...',
  signInCancelNote: 'Si vous annulez la connexion, vous pouvez continuer en tant qu’invité. Certaines fonctionnalités seront indisponibles.',
  processing: 'Traitement...',
  recoverConfirmTitle: 'Confirmer le remplacement des données',
  recoverConfirmMessage: 'Des données existantes sont liées à ce compte. Continuer remplacera les données d’invité sur cet appareil. Voulez-vous continuer ?',
  recoverConfirmContinue: 'Restaurer',
  recoverConfirmCancel: 'Annuler',
  unlinkConfirmTitle: 'Dissocier le compte',
  unlinkConfirmMessage: 'Si vous dissociez ce fournisseur, cet appareil reviendra au mode invité. Vos données Hub restent disponibles si vous vous reconnectez avec le même fournisseur sur un autre appareil.',
  unlinkConfirmContinue: 'Dissocier',
  unlinkConfirmCancel: 'Annuler',
  deleteConfirmTitle: 'Confirmer la suppression du compte',
  deleteConfirmMessage: 'Supprimer votre compte effacera vos scores, données de connexion, comptes liés et invitations.\nCette action est irréversible. Voulez-vous vraiment continuer ?',
  deleteConfirmContinue: 'Supprimer le compte',
  deleteConfirmCancel: 'Annuler',
  adNekoTitle: 'AD neko',
  matchmakingRemaining: '{seconds}s restantes',
  matchmakingTimeoutMessage: 'Aucun adversaire trouvé à temps. Veuillez réessayer.',
  difficultyEasyName: 'Casual',
  difficultyEasyDescription: 'L’adversaire est un peu distrait',
  difficultyNormalName: 'Normal',
  difficultyNormalDescription: 'L’adversaire fait parfois des erreurs',
  difficultyHardName: 'Difficile',
  difficultyHardDescription: 'L’adversaire voit mieux le plateau',
  difficultyHellName: 'Extrême',
  difficultyHellDescription: 'L’adversaire est fort et anticipe vos coups',
}
